const CONFIG = {
	months: [
		'January',
		'February',
		'March',
		'April',
		'May',
		'June',
		'July',
		'August',
		'September',
		'October',
		'November',
		'December',
	],
	tags: [
		'articles',
		'css-in-js',
		'browsers',
		'frameworks',
		'methodology',
		'preprocessors',
		'react',
		'resets',
		'standards',
		'tools',
		'websites',
	],
	years: Array(40)
		.fill(0)
		.map((_, i) => 1990 + i),
};

export default CONFIG;
